'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.setRequest = setRequest;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET = 'httpRequest/SET';

var initialState = {
  req: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET:
      return (0, _extends3.default)({}, state, {
        req: action.req
      });
    default:
      return state;
  }
}

function setRequest(req) {
  return {
    type: SET,
    req: req
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/httpRequest.js
// module id = 1246
// module chunks = 0